import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import emailLogo from "@/assets/email-logo.png";

const UploadEmailLogo = () => {
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState<string | null>(null);

  const uploadLogo = async () => {
    setUploading(true);
    try {
      // Fetch the logo from src/assets
      const response = await fetch(emailLogo);
      const blob = await response.blob();
      
      // Upload directly to Supabase storage
      const { data, error } = await supabase.storage
        .from('style-previews')
        .upload('email-logo.png', blob, {
          contentType: 'image/png',
          upsert: true
        });

      if (error) throw error;

      const { data: urlData } = supabase.storage
        .from('style-previews')
        .getPublicUrl('email-logo.png');

      setResult(urlData.publicUrl);
      toast.success("Logo uploaded successfully!");
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <div className="max-w-md w-full space-y-6 text-center">
        <h1 className="text-2xl font-bold">Upload Email Logo</h1>
        
        <div className="p-4 bg-muted rounded-lg">
          <img src={emailLogo} alt="Email Logo" className="w-24 h-24 mx-auto" />
          <p className="mt-2 text-sm text-muted-foreground">Logo to upload</p>
        </div>

        <Button onClick={uploadLogo} disabled={uploading} className="w-full">
          {uploading ? "Uploading..." : "Upload to Storage"}
        </Button>

        {result && (
          <div className="p-4 bg-green-50 dark:bg-green-900/20 rounded-lg text-left">
            <p className="text-sm font-medium text-green-800 dark:text-green-200">Success!</p>
            <p className="text-xs text-green-600 dark:text-green-300 break-all mt-1">{result}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadEmailLogo;
